import { HttpErrorResponse } from '@angular/common/http';

import { pipeState } from '../utils';
import { NotNull, SingleEntityAdapter, SingleEntityState } from './types';

export type SingleEntityActions<Entity> = {
  fetchSuccess: (state: SingleEntityState<Entity>, data: Entity) => SingleEntityState<Entity>;
  fetchFailed: (
    state: SingleEntityState<Entity>,
    error: HttpErrorResponse,
  ) => SingleEntityState<Entity>;
  fetch: (state: SingleEntityState<Entity>) => SingleEntityState<Entity>;
  update: (
    state: SingleEntityState<Entity>,
    data: Partial<NotNull<Entity>>,
  ) => SingleEntityState<Entity>;
  updateSuccess: (
    state: SingleEntityState<Entity>,
    data: NotNull<Entity>,
  ) => SingleEntityState<Entity>;
  updateFailed: (
    state: SingleEntityState<Entity>,
    error: HttpErrorResponse,
  ) => SingleEntityState<Entity>;
};

export const getSingleEntityActions = <Entity>(
  adapter: SingleEntityAdapter<Entity>,
): SingleEntityActions<Entity> => ({
  fetch: state => adapter.markAsPending(state),
  fetchSuccess: (state, data) =>
    pipeState(
      state,
      next => adapter.save(next, data),
      next => adapter.markAsLoaded(next),
    ),
  fetchFailed: (state, error) => adapter.setError(state, error),

  update: (state, data) => adapter.markAsPending(state),
  updateSuccess: (state, data) =>
    pipeState(
      state,
      next => adapter.update(next, data),
      next => adapter.markAsLoaded(next),
    ),
  updateFailed: (state, error) => adapter.setError(state, error),
});
